<template>
  <div class="container switch-page">
    <!-- 头部导航 -->
    <header-bar name="待处理投诉" />

    <div class="wrap-box">
      <div class="hd">订单信息</div>
      <div class="base-wrap">
        <div class="row">
          <div class="lab">单号</div>
          <div class="inf">{{ complaintList.sn }}</div>
        </div>
        <div class="row">
          <div class="lab">价格</div>
          <div class="num">￥{{ complaintList.price }}</div>
        </div>
        <div class="row">
          <div class="lab">投诉日期</div>
          <div class="inf">{{ complaintList.createTime }}</div>
        </div>
        <div class="row">
          <div class="lab">下单人</div>
          <div class="inf">
            {{ complaintList.sendUserName }} - {{ complaintList.sendUserPhone }}
          </div>
        </div>
        <div class="row">
          <div class="lab">下单时间</div>
          <div class="inf">{{ complaintList.sendUserCreateTime }}</div>
        </div>
        <div class="row">
          <div class="lab">接单人</div>
          <div class="inf">
            {{ complaintList.receivingUserName }} -
            {{ complaintList.receivingUserPhone }}
          </div>
        </div>
        <div class="row">
          <div class="lab">接单时间</div>
          <div class="inf">{{ complaintList.receivingUserCreateTime }}</div>
        </div>
      </div>
    </div>

    <div class="wrap-box">
      <div class="hd">服务内容</div>
      <div class="base-wrap">
        <div class="row">
          <div class="lab">服务类型</div>
          <div class="inf">{{ orderType[complaintList.orderType] }}</div>
        </div>
        <div class="row">
          <div class="lab">预约时间</div>
          <div class="inf">
            {{ complaintList.orderAccompanyInfoDTO.appointmentTime }}
          </div>
        </div>
        <div class="row">
          <div class="lab">就诊人</div>
          <div class="inf">
            {{ complaintList.orderAccompanyInfoDTO.name }} -
            {{ complaintList.orderAccompanyInfoDTO.phone }}
          </div>
        </div>
        <div class="row">
          <div class="lab">就诊人年龄</div>
          <div class="inf">
            {{ complaintList.orderAccompanyInfoDTO.birthday | rAge }}
          </div>
        </div>
        <div class="row">
          <div class="lab">监护人</div>
          <div class="inf">
            {{ complaintList.orderAccompanyInfoDTO.guardian_name }} -
            {{ complaintList.orderAccompanyInfoDTO.guardian_number }}
          </div>
        </div>
        <div class="row">
          <div class="lab">开始时间</div>
          <div class="inf">
            {{ complaintList.orderAccompanyInfoDTO.startDateTime }}
          </div>
        </div>
        <div class="row">
          <div class="lab">结束时间</div>
          <div class="inf">
            {{ complaintList.orderAccompanyInfoDTO.endDateTime }}
          </div>
        </div>
      </div>
    </div>

    <div class="wrap-box">
      <div class="hd">投诉内容</div>
      <div class="introduction">{{ complaintList.remarks }}</div>
    </div>

    <div class="wrap-box">
      <div class="hd">相关附件</div>
      <div class="file-wrap">
        <div
          class="up-item"
          v-for="(item, index) in complaintEnclosureList"
          :key="index"
        >
          <div class="in-file">
            <img class="pic" :src="item.url" />
          </div>
        </div>
      </div>
    </div>

    <div class="fixed-link" @click="handlerModel">处理投诉</div>

    <van-overlay :show="flagModels">
      <div class="model-box">
        <div class="hd">
          <div class="name">处理投诉</div>
          <div class="link" @click="handlerModel">
            <img class="ico" src="~assets/images/icon-close.png" />
          </div>
        </div>
        <div class="bd">
          <div class="area">
            <div class="lab required">请输入处理结果</div>
            <div class="txt">
              <textarea class="text" v-model="floResult"></textarea>
            </div>
          </div>

          <div class="line">
            <div class="lab required">
              可退金额<span class="digtal"
                >(当前订单金额：￥{{ complaintList.price }})</span
              >
            </div>
            <div class="txt">
              <input type="text" class="in-text" v-model="floMoney" />
            </div>
          </div>
          <div class="line">
            <div class="lab required">
              扣除得分<span class="digtal"
                >(当前用户积分：{{ complaintList.weight }}分)</span
              >
            </div>
            <div class="stepper">
              <van-stepper
                v-model="floScore"
                step="0.1"
                :decimal-length="1"
                :max="complaintList.weight"
                :min="0"
              />
            </div>
          </div>
        </div>
        <div class="ft">
          <div class="link" @click="handlerSaveTask">提交</div>
        </div>
      </div>
    </van-overlay>
  </div>
</template>

<script>
import HeaderBar from "components/HeaderBar/HeaderBar";
import { validateNumber } from "@/utils/validate";
import { complaintDetails, complaintShow, complaintUpdate } from "@/api/home";
export default {
  name: "ServiceDetail",
  components: {
    HeaderBar,
  },
  data() {
    return {
      complaintList: {
        orderDrugInfoDTO: "",
        orderAskInfoDTO: "",
        orderConsequenceInfoDTO: "",
        orderAccompanyInfoDTO: "",
      },
      complaintEnclosureList: [],
      flagModels: false,
      textResult: "",
      floMoney: 150,
      floScore: 5,
      floResult: "",
      orderType: {
        ACCOMPANY_DIAGNOSE: "陪诊",
        BUY_MEDICINE: "买药",
        INTERROGATION_DIAGNOSE: "问诊",
        SEND_RESULTS: "送取结果",
      },
    };
  },
  methods: {
    show: function (id) {
      complaintDetails({ id: id }).then((res) => {
        res.result.orderAccompanyInfoDTO =
          res.result.orderAccompanyInfoDTO == null
            ? {}
            : res.result.orderAccompanyInfoDTO;
        this.complaintList = res.result;
        this.floMoney = this.complaintList.price;
        this.floScore = this.complaintList.weight;
      });
      complaintShow({ id: id }).then((res) => {
        this.complaintEnclosureList = res.result;
      });
    },

    // 处理投诉
    handlerSaveTask: function () {
      if (this.floResult.length <= 0) {
        this.$toast("请输入处理结果");
        return;
      }

      if (!validateNumber(this.floMoney)) {
        this.$toast("请输入数字");
        return;
      }

      if (Number(this.floMoney) > Number(this.complaintList.price)) {
        this.$toast("不能超过订单金额");
        return;
      }
      this.$dialog
        .confirm({
          //   title: "提交",
          message: "确认是否执行当前操作",
        })
        .then(() => {
          complaintUpdate({
            orderId: this.complaintList.orderId,
            id: this.complaintList.id,
            state: "3",
            processingResults: this.floResult,
            price: this.floMoney,
            weight: Number(this.floScore),
          }).then((res) => {
            this.$toast("处理完成");
            this.handlerModel();
            this.$router.go(-1);
            // this.$router.push({path: '/service-list'})
          });
        })
        .catch(() => {});
    },

    // 打开弹窗
    handlerModel: function () {
      this.flagModels = !this.flagModels;
    },
  },
  mounted: function () {
    this.show(this.$route.query.code);
  },
};
</script>

<style scoped>
.wrap-box {
  padding: 0 0.2rem;
  margin: 0.2rem 0.2rem 0;
  background: #fff;
  border-radius: 0.2rem;
}
.wrap-box > .hd {
  height: 0.88rem;
  line-height: 0.88rem;
  color: #111;
  font-size: 0.28rem;
  font-weight: 600;
  display: flex;
  justify-content: flex-start;
  align-items: center;
}
.wrap-box > .hd::before {
  position: relative;
  content: "";
  margin: 0 0.1rem 0 0;
  width: 0.08rem;
  height: 0.32rem;
  background: #3f58fd;
}

.base-wrap {
  padding: 0 0 0.2rem;
  font-size: 0.28rem;
}
.base-wrap > .row {
  position: relative;
  height: 0.8rem;
  line-height: 0.8rem;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.base-wrap > .row::after {
  position: absolute;
  content: "";
  left: 0;
  right: 0;
  bottom: 0;
  height: 1px;
  background: rgba(0, 0, 0, 0.04);
}
.base-wrap > .row > .lab {
  color: #999;
  position: relative;
}
.base-wrap > .row > .lab::after {
  position: relative;
  content: "：";
}
.base-wrap > .row > .inf {
  color: #555;
}
.base-wrap > .row > .num {
  color: #c00;
  font-weight: 600;
}

.introduction {
  padding: 0 0 0.2rem;
  color: #565656;
  font-size: 0.28rem;
  line-height: 0.48rem;
}

.file-wrap {
  display: flex;
  flex-wrap: wrap;
  margin: -0.3rem 0 0;
  padding: 0 0 0.3rem;
  white-space: normal;
  word-wrap: normal;
  word-break: normal;
}
.file-wrap > .up-item {
  flex: 1;
  -ms-flex: 0 0 33.33%;
  flex: 0 0 33.33%;
  max-width: 33.33%;
  padding: 0 0.15rem;
  margin: 0.3rem 0 0;
  box-sizing: border-box;
}
.file-wrap > .up-item > .in-file {
  width: calc((100vw - 0.4rem - 0.4rem) * 0.3333 - 0.3rem);
  height: calc((100vw - 0.4rem - 0.4rem) * 0.3333 - 0.3rem);
  background: #f4f3f3;
  box-sizing: border-box;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  border-radius: 0.1rem;
  -webkit-border-radius: 0.1rem;
  -moz-border-radius: 0.1rem;
  -ms-border-radius: 0.1rem;
  -o-border-radius: 0.1rem;
}
.file-wrap > .up-item > .in-file > .pic {
  border-radius: 0.1rem;
  -webkit-border-radius: 0.1rem;
  -moz-border-radius: 0.1rem;
  -ms-border-radius: 0.1rem;
  -o-border-radius: 0.1rem;
}

.fixed-link {
  position: fixed;
  left: 0.2rem;
  right: 0.2rem;
  bottom: 0.14rem;
  height: 0.88rem;
  line-height: 0.88rem;
  text-align: center;
  color: #fff;
  font-size: 0.32rem;
  border-radius: 0.88rem;
  background: #3f58fd;
}
</style>